if (!customElements.get("wholesale-partnership-terms")) {
  const DESKTOP_MIN = 990;
  /** Lower = activation line moves up → next step highlights later on scroll (mobile only). */
  const MOBILE_LINE_RATIO = 0.2;

  class WholesalePartnershipTerms extends HTMLElement {
    constructor() {
      super();
      this._track = null;
      this._steps = [];
      this._mq = null;
      this._onScroll = null;
      this._raf = 0;
    }

    connectedCallback() {
      this._track = this.querySelector("[data-wpt-track]");
      this._steps = Array.from(this.querySelectorAll("[data-wpt-step]"));
      this._mq = window.matchMedia(`(min-width: ${DESKTOP_MIN}px)`);
      this._onScroll = () => {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => {
          this._raf = 0;
          this._updateActive();
        });
      };
      this._onMqChange = () => this._syncMode();

      this._syncMode();
      this._mq.addEventListener("change", this._onMqChange);
      window.addEventListener("scroll", this._onScroll, { passive: true });
      window.addEventListener("resize", this._onScroll, { passive: true });
      this._updateActive();
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this._onScroll);
      window.removeEventListener("resize", this._onScroll);
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = 0;
      if (this._mq && this._onMqChange) {
        this._mq.removeEventListener("change", this._onMqChange);
      }
    }

    _syncMode() {
      if (!this._steps.length) return;
      this._updateActive();
    }

    _updateActive() {
      if (!this._track || !this._steps.length) return;

      const n = this._steps.length;
      let activeIndex;

      if (this._mq.matches) {
        const rect = this.getBoundingClientRect();
        const top = window.scrollY + rect.top;
        const trackH = this._track.offsetHeight;
        const vh = window.innerHeight;
        const scrollable = Math.max(1, trackH - vh);
        const scrolled = window.scrollY - top;
        const p = Math.max(0, Math.min(1, scrolled / scrollable));
        activeIndex = Math.min(n - 1, Math.floor(p * n));
      } else {
        const line = window.innerHeight * MOBILE_LINE_RATIO;
        let idx = -1;
        this._steps.forEach((el, i) => {
          if (el.getBoundingClientRect().top < line) idx = i;
        });
        activeIndex = Math.min(n - 1, Math.max(0, idx));
      }

      this._steps.forEach((el, i) => {
        el.classList.toggle("is-active", i <= activeIndex);
      });
    }
  }

  customElements.define("wholesale-partnership-terms", WholesalePartnershipTerms);
}
